{
  "RESET_PASSWORD": {
    "TITLE": "Nollaa salasana",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Sähköposti",
      "PLACEHOLDER": "Ole hyvä ja syötä sähköpostiosoitteesi.",
      "ERROR": "Ole hyvä ja syötä validi sähköposti."
    },
    "API": {
      "SUCCESS_MESSAGE": "Salasanan palautuslinkki on lähetetty sähköpostiisi.",
      "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
    },
    "SUBMIT": "Lähetä"
  }
}
